/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Grid } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import styles from "./styles.module.scss";
import { AppAPIService } from "../../../../../../../services/AppAPIService";
import Loading from "../../../../../../home/components/Loading";
import InputForm from "../../../../../../../components/InputForm";
import FormActions from "../../../../../components/FormActions";

export const ChatGptForm = (props) => {
  let api = AppAPIService.getInstance();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const [translateText, setTranslateText] = useState("");
  const [translateTextRole, setTranslateTextRole] = useState("");
  const [translateTextError, setTranslateTextError] = useState("");
  const handleInputDays = (e) => {
    if (e.length < 1) {
      setTranslateText("");
      setTranslateTextError("Campo obrigatório");
      setTranslateTextRole("notOk");
      return;
    } else {
      setTranslateText(e);
      setTranslateTextError("");
      setTranslateTextRole("ok");
    }
  };

  const formIsValid = useCallback(() => {
    let validForm = true;

    validForm = translateText !== "" && translateTextRole === "ok";

    return validForm;
  }, [translateText, translateTextRole]);

  const getConfig = async () => {
    try {
      setIsLoading(true);

      const response = await api.makeHttpRequest({
        url: `/integration`,
        method: "GET",
        params: {
          values: JSON.stringify([
            {
              integration: "CHAT_GPT",
              key: "translateText",
            },
          ]),
        },
      });

      const config = Array.isArray(response?.data) ? response.data : response || [];
      const translateText = config.find(
        (integration) => integration.key === "translateText"
      )?.value || "";

      setTranslateText(translateText);
      setTranslateTextRole("ok");

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);

      console.error("CHAT_GPT_CONFIG_LOAD_ERROR", {
        message: error?.message,
        status: error?.response?.status,
        payload: error?.response?.data,
      });
      setTranslateText("");
      setTranslateTextRole("");
    }
  };

  useEffect(() => {
    getConfig();
  }, []);

  const submitCreation = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    try {
      setIsLoading(true);
      await api.makeHttpRequest({
        url: `/integration`,
        method: "POST",
        data: {
          values: [
            {
              integration: "CHAT_GPT",
              key: "translateText",
              value: String(translateText),
            },
          ],
        },
      });

      setIsLoading(false);
      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: "Configurações criada com sucesso",
      }).then(() => {
        history.push("/admin/parametrizacao");
      });
    } catch (error) {
      console.error("error: ", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  /* end submitCreation */

  /* clean form */
  const onCleanForm = async () => {
    setTranslateText("");
    setTranslateTextError("");
    setTranslateTextRole("");
  };

  /* end clean form */
  return (
    <>
      <Container
        style={{
          display: "block",
          margin: "0",
          padding: "0",
        }}
        maxWidth="xl"
      >
        <Loading isLoading={isLoading} />
        <Container
          style={{
            width: "100%",
            display: "block",
            padding: 0,
            margin: "0 !important",
          }}
          maxWidth="xl"
        >
          <form
            className={styles.form}
            autoComplete="off"
            style={{
              padding: "0 !important",
              margin: "0 !important",
            }}
          >
            <div
              className={styles.containerInputs}
              style={{
                padding: "0 !important",
              }}
            >
              <Grid container style={{}}>
                <Grid md={12}>
                  <InputForm
                    type="text"
                    name="translateText"
                    placeholder="Digite o texto que será utilizado para resumir as publicações"
                    label="Texto para resumo de publicações"
                    value={translateText}
                    error={translateTextError}
                    onChange={handleInputDays}
                    role={translateTextRole}
                    required
                  />
                </Grid>
              </Grid>
            </div>
          </form>
        </Container>
        <div className={styles.buttonsContainer}>
          <FormActions
            module={"parametrizacao"}
            formIsValid={formIsValid()}
            onCleanForm={onCleanForm}
            onSubmit={submitCreation}
            hideCancel={true}
            messagem
          />
        </div>
      </Container>
    </>
  );
};
